import {Modal, ModalContent} from "semantic-ui-react";
import React, {useState} from "react";
import {useMutation, useQuery} from "@tanstack/react-query";
import {getVehicleDetails, licensePlateToVIN, updateVehicles} from "../services/Vehicles";
import {addDriver, getDrivers} from "../services/Drivers";
import queryClient from "../react-query/QueryClient";
import {FETCH_DRIVERS} from "../react-query/QueryConstant";
import {useSelector} from "react-redux";
import {getPersonalInfo} from "../redux/slices/PersonalAccountInformationSlice";
import {AddVehicle, AddDriver} from 'caradvise_shared_components';
import {notifyToaster} from "../helpers/common";
import {GENERIC_ERROR_MESSAGE} from "../constants/common";
import {TOASTIFY_STATUS} from "../constants/application";
import {gaJSON, useTrackFirebaseAnalytics} from "../utils/googleAnalytics";

const AddVehicleModal = ({card, setCard, updateVehicleStatus, vehicle, setVehicle, vehicles}) => {
    const [openDriverModal, setOpenDriverModal] = useState(false);
    const [error, setError] = useState({});
    const [driver, setDriver] = useState(null);
    const [loading, setLoading] = useState(false);
    const { fleet_id } = useSelector((state) => getPersonalInfo(state)) || {};

    const submitDriver = (data) => {
        data.role = 'Driver';
        data.fleet_id = fleet_id;
        createDriver({customer:data})
    }

    const personalInfo = useSelector((state) => getPersonalInfo(state));

    const getVehicleInfo = async (rawData) => {
        try {
            rawData.cache = true;
            setLoading(true);
            if (rawData.license) {
                const vehicle = await licensePlateToVIN(rawData)
                console.log(vehicle)
                rawData.vin = vehicle.vin;
            }

            getVehicleDetails(rawData).then(() => {
                    setError({vin: true})
                    setLoading(false);
                }
            ).catch(
                () => {
                    rawData.cache = false;
                    getVehicleDetails(rawData).then(
                        (data) => {
                            if(rawData.license) {
                                data.result.vehicle_lookup.vin = rawData.vin;
                            }
                            setVehicle(data?.result?.vehicle_lookup);
                        }
                    ).catch((error) => notifyToaster(error || GENERIC_ERROR_MESSAGE, {
                            type: TOASTIFY_STATUS.error,
                        })
                    ).finally(() => setLoading(false));
                }
            )
        } catch (error) {
            setError({license: true})
            setLoading(false);
            notifyToaster(error.toString() || GENERIC_ERROR_MESSAGE, {
                type: TOASTIFY_STATUS.error,
            })
        }
    }

    const { mutate: editVehicles } = useMutation({
        mutationFn: (data) => {
            setLoading(true);
            // TODO: Update vehicle id to the correct vehicle id
            return updateVehicles({
                apiPayload: data,
                vehicleId: card.id,
            });
        },
        onSuccess: (data) => {
            updateVehicleStatus({vehicle:card, enroll_code:"enrolled"})
        },
        onError: (error) => {
        },
        onSettled: (data) => {
            setLoading(false);
        }
    })
    const track = useTrackFirebaseAnalytics();

    const { mutate: createDriver } = useMutation({
        mutationFn: (data) => {
            setLoading(true);
            return addDriver(data)
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries(FETCH_DRIVERS);
            setDriver(data.result);
            setOpenDriverModal(false)
            track(gaJSON.onboarding_driver_added, {
                card_count:vehicles.result.length
            })
        },
        onError: (error) => {
        },
        onSettled: (data) => {
            setLoading(false);
        }
    });

    const { data: drivers } = useQuery({
        queryKey: [FETCH_DRIVERS],
        queryFn: () => getDrivers({ fleetId: fleet_id }),
        enabled: !!personalInfo?.fleet_id,
        select: (data) => {
            const driverList =
                data?.result?.map((driver) => {
                    return {
                        key: driver?.id,
                        value: driver?.id,
                        text: driver?.name,
                    };
                }) || [];
            return driverList;
        },
    })

    const closeModal = () => {
        setCard(null)
        setVehicle(null)
    }

    return <>
        <Modal
            open={card}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            onClose={() => {
                closeModal()
            }}
            size="tiny"
        >
            <ModalContent>
                {card &&
                    <AddVehicle showAddDriver={() => setOpenDriverModal(true)} getVehicle={getVehicleInfo} error={error}
                                vehicle={vehicle} setVehicle={setVehicle} drivers={drivers}
                                confirmVehicle={editVehicles}
                                driver={driver} card={card} loading={loading}
                                closeModal={closeModal}/>}
            </ModalContent>
        </Modal>
        <Modal open={openDriverModal} size="tiny">
            <ModalContent>
                <AddDriver closeModal={() => setOpenDriverModal(false)} addDriver={submitDriver} loading={loading} />
            </ModalContent>
        </Modal>
    </>
}

export default AddVehicleModal;
